export default __webpack_public_path__ + "static/media/large.5822b5cf.jpg";